// extracted by mini-css-extract-plugin
module.exports = {"label":"Count_label__YHc67","count":"Count_count__AwTkW"};